





































































































































































import { storeRefDokter } from "@/store/modules/bridgingVclaim/RefDokter";
import { storeRefPoli } from "@/store/modules/bridgingVclaim/RefPoli";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SRK from "@/services/bridgingVclaim/SRK";
import { appModule } from "@/store/modules/app";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";

@Component({
  components: { ModalKonfirmasi },
})
export default class InputSRK extends Vue {
  // @Prop() dtSrk: object;
  noSep: "";
  noKartu: "";
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  tglShowSRK = false;
  tglSRK = "";
  poli = "";
  dokter = "";
  cm = "";
  noSrk = "";
  saving = false;
  printing = false;
  deleting = false;
  // showDokter = true;

  get listPoli() {
    return storeRefPoli.refPoli;
  }

  get listDokter() {
    return storeRefDokter.refDokter;
  }

  get sep() {
    return storeSEP.sep;
  }

  @Watch("sep")
  ceksrk(val) {
    this.noSep = val.noSep;
    this.noKartu = val.noKartu;
    if (val.srk) {
      this.noSrk = val.srk.noSuratKontrol;
      this.cm = val.noMr;
      this.tglSRK = val.srk.tglRencanaKontrol;
      this.poli = val.srk.poli.kode;
      this.dokter = val.srk.dokter.kode;
    } else {
      this.noSrk = "";
      this.cm = val.noMr;
      this.tglSRK = "";
      this.poli = "";
      this.dokter = "";
    }
  }
  // @Watch("dtSrk")
  // cekDtSrk(val) {
  //   if (val) {
  //     this.noSrk = val.noSuratKontrol;
  //     this.cm = val.noMr;
  //     this.tglSRK = val.tglRencanaKontrol;
  //     this.poli = val.poli.kode;
  //     this.dokter = val.dokter.kode;
  //   } else {
  //     this.noSrk = "";
  //     this.cm = "";
  //     this.tglSRK = "";
  //     this.poli = "";
  //     this.dokter = "";
  //   }
  // }

  // get lastNoSEP() {
  //   return storeSEP.lastNoSEP;
  // }

  // get headers() {
  //   const head = [
  //     {
  //       text: "Nomor SRK",
  //       value: "noSep",
  //       width: "20vh",
  //       align: "left",
  //     },
  //     {
  //       text: "Poli",
  //       filterable: false,
  //       value: "tgl",
  //       width: "10vh",
  //       align: "left",
  //     },
  //     {
  //       text: "Dokter",
  //       filterable: false,
  //       value: "poli",
  //       width: "10vh",
  //       align: "left",
  //     },
  //     {
  //       text: "Tgl Kontrol",
  //       filterable: false,
  //       value: "noRujukan",
  //       width: "20vh",
  //       align: "left",
  //     },
  //     {
  //       text: "Aksi",
  //       filterable: false,
  //       value: "aksi",
  //       width: "22vh",
  //       align: "center",
  //     },
  //   ];
  //   return head;
  // }

  get dataSRK() {
    return {
      noSEP: this.noSep,
      noKartu: this.noKartu,
      noMr: this.cm,
      kodeDokter: this.dokter,
      poliKontrol: this.poli,
      tglRencanaKontrol: this.tglSRK,
      user: "Coba Ws",
    };
  }

  get editSRK() {
    return {
      noSuratKontrol: this.noSrk,
      noSEP: this.noSep,
      noKartu: this.noKartu,
      noMr: this.cm,
      kodeDokter: this.dokter,
      poliKontrol: this.poli,
      tglRencanaKontrol: this.tglSRK,
      user: "Coba Ws",
    };
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }

  simpan() {
    console.log("simpan", this.dataSRK);
    if (!this.saving) {
      this.saving = true;
      SRK.create(this.dataSRK)
        .then((resp) => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            // this.clear();
            console.log("resp", resp);
            appModule.NoticeDelay("Berhasil Membuat SRK, no SRK=" + this.noSrk);
            // appModule.NoticeDelay("Berhasil Membuat SRK");
            storeSEP.act_get_sep(this.noSep);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  ubah() {
    if (!this.saving) {
      this.saving = true;
      SRK.edit(this.editSRK)
        .then((resp) => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            // this.clear();
            console.log("resp", resp);
            appModule.NoticeDelay("Berhasil Mengubah SRK");
            storeSEP.act_get_sep(this.noSep);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  cetak() {
    if (!this.printing) {
      this.printing = true;
      SRK.print(this.noSrk);
      this.printing = false;
    }
  }

  konfirmHapus() {
    this.modalOpenKonfirmasi = true;
    this.msgConfirm = "Anda yakin ingin menghapus SRK dengan no: " + this.noSrk;
  }

  hapus() {
    const dt = {
      noSuratKontrol: this.noSrk,
      user: "Coba Ws",
    };
    if (!this.deleting) {
      this.deleting = true;
      SRK.hapus(dt)
        .then((resp) => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            appModule.NoticeDelay("Berhasil Menghapus SRK");
            storeSEP.act_get_sep(this.noSep);
          }
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  }
}
